/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { useKeystoneSession } from '../../auth/use-keystone-session';
import { IslandSkuAssetData, IslandSkuData } from '@rta/rta-blueprint-library';
import { useEffect, useState } from 'react';

import { NavType } from '@state';
import { getProducts } from '@external';

// Singleton state outside the component
let accessoryItemDataCache: IslandSkuAssetData | null = null;
let loadPromise: Promise<IslandSkuAssetData> | null = null;

export const useLoadIslandSkuData = (): IslandSkuAssetData | null => {
	const { getToken, status } = useKeystoneSession();
	const isAuthenticated = status === 'ready';

	const [accessoriesItemData, setComponentItemData] = useState<IslandSkuAssetData | null>(accessoryItemDataCache);

	useEffect(() => {
		if (!isAuthenticated) return;

		if (accessoryItemDataCache) {
			return;
		}

		if (loadPromise) {
			loadPromise.then(setComponentItemData);
			return;
		}

		loadPromise = (async () => {
			try {
				const accessoriesData = await getProducts<Record<string, IslandSkuData>>({
					fileName: 'island-skus-item-data',
					getToken,
					setError: (error) => console.error('Error loading accessories:', error)
				});

				accessoryItemDataCache = IslandSkuAssetData.getInstance({
					callback: () => (accessoriesData || {})
				});

				console.log('Loaded accessories:', accessoryItemDataCache, accessoriesData);
				return accessoryItemDataCache;
			} catch (error) {
				console.error('Failed to load accessories data:', error);
				accessoryItemDataCache = IslandSkuAssetData.getInstance({
					callback: () => ({})
				});
				return accessoryItemDataCache;
			}
		})();

		loadPromise.then(setComponentItemData);
	}, [isAuthenticated]);

	return accessoriesItemData;
};
